import React, { useEffect, useRef, useState } from "react";

const EMAIL_DOMAINS = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com"];

const EmailInput = ({
  index,
  name,
  value,
  onChange,
  placeholder = "Enter email",
  maxLength = 50,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const itemRefs = useRef([]);

  const handleKeyDown = (e) => {
    if (e.target.name?.toLowerCase().includes("email") && e.key === " ") {
      e.preventDefault();
      return;
    }

    if (suggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();

      setActiveIndex((prev) => (prev < suggestions.length - 1 ? prev + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();

      setActiveIndex((prev) => (prev > 0 ? prev - 1 : suggestions.length - 1));
    } else if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        handleSuggestionClick(suggestions[activeIndex]);
      }
    }
  };

  useEffect(() => {
    if (activeIndex >= 0) {
      itemRefs.current[activeIndex]?.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    setActiveIndex(suggestions.length > 0 ? 0 : -1);
  }, [suggestions]);

  const triggerChange = (val) => {
    if (index !== undefined && index !== null) {
      onChange(index, name, val);
    } else {
      onChange(name, val);
    }
  };

  const handleInputChange = (e) => {
    let val = e.target.value;

    val = val.replace(/[^A-Za-z0-9._+\-@]/g, "");


    triggerChange(val);

    if (val.includes("@")) {
      const [username, domainPart = ""] = val.split("@");

      if (username) {
        const filtered = EMAIL_DOMAINS.filter((domain) =>
          domain.startsWith(domainPart.toLowerCase()),
        ).map((domain) => `${username}@${domain}`);

        setSuggestions(filtered);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (email) => {
    triggerChange(email);
    setSuggestions([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div ref={wrapperRef} className="relative">
      <input
        type="email"
        name={name}
        value={value || ""}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        maxLength={maxLength}
        autoComplete="new-password"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className="w-full border p-2 rounded"
      />

      {suggestions.length > 0 && (
        <div className="proposal-autocomplete-dropdown">
          {suggestions.map((item, idx) => (
            <div
              key={item.email}
              ref={(el) => (itemRefs.current[idx] = el)}
              onMouseDown={() => handleSuggestionClick(item)}
              className={`proposal-autocomplete-option ${
                activeIndex === idx ? "active" : ""
              }`}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailInput;
